import { load } from '@cashfreepayments/cashfree-js';

type CashfreeMode = 'sandbox' | 'production';

function getCashfreeMode(): CashfreeMode {
  const mode = import.meta.env.VITE_CASHFREE_ENVIRONMENT ?? 'sandbox';
  return mode === 'production' ? 'production' : 'sandbox';
}

let cashfreePromise: ReturnType<typeof load> | null = null;

function getCashfreeInstance() {
  if (!cashfreePromise) {
    cashfreePromise = load({ mode: getCashfreeMode() });
  }
  return cashfreePromise;
}

export async function launchCashfreeCheckout(paymentSessionId: string): Promise<void> {
  const cashfree = await getCashfreeInstance();
  await cashfree.checkout({
    paymentSessionId,
    // Modal overlay — stays on your site; easier to see than full-page redirect from a dialog
    redirectTarget: '_modal',
  });
}
